import { MsalProvider } from '@azure/msal-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import './index.css';
import { msalInstance } from './lib/msal.js';

async function bootstrap(): Promise<void> {
  await msalInstance.initialize();
  const container = document.getElementById('root');
  if (!container) throw new Error('root element not found');
  createRoot(container).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MsalProvider>
    </StrictMode>,
  );
}

void bootstrap().catch((err: unknown) => {
  console.error('portal failed to start', err);
});
